import { Outlet, createRootRoute, useNavigate, useLocation } from '@tanstack/react-router'
import { useAuth } from '../contexts/AuthContext'
import { useEffect } from 'react'
import { PageLoader } from '@/components/ui/loader'

function RootComponent() {
  const { isAuthenticated, loading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    // Don't redirect if still loading
    if (loading) return

    const publicPaths = ['/login', '/register']
    const isPublicPath = publicPaths.some(path => location.pathname.startsWith(path))

    // Redirect to login if not authenticated and not on a public path
    // Include the current path as redirectTo so user can return after login
    if (!isAuthenticated && !isPublicPath) {
      navigate({ to: '/login', search: { redirectTo: location.pathname } })
    }
  }, [isAuthenticated, loading, location.pathname, navigate])

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center">
        <PageLoader />
      </div>
    )
  }

  // Render the app
  return <Outlet />
}

export const rootRoute = createRootRoute({
  component: RootComponent,
})
